import Phaser from 'phaser';
import { Colors } from '../../consts/Colors';
export default class Card1 extends Phaser.GameObjects.Container {
    constructor(scene, x, y, cardData) {
        super(scene, x, y, []);

        scene.add.existing(this);
        this.initPosition = { x: x, y: y }
        this.scene = scene;
        this.cardData = cardData;
        this.zoneId = cardData.id;
        this.firstDrop = true
        
        this.cardImage = this.scene.add.image(0, 0, cardData.name).setOrigin(0.5);
        this.add(this.cardImage);

        this.setSize(this.cardImage.width, this.cardImage.height);
    }

    getName(){
        return this.cardData.name
    }

    dragEnd(pointer, gameObject, dropped) {
        if (!dropped) {
            gameObject.resetPosition()
        }
    }


    onDrag() {
        
    }

    setDone() {
        this.isDone = true
        this.cardImage.setTexture(this.cardData.name + "_ok")
    }

    setTrue(){
        this.cardImage.setTexture(this.cardData.name + "_true")

    }

    resetPosition(duration = 300) {
        this.scene.tweens.add({
            targets: this,
            duration: duration,
            x: this.initPosition.x,
            y: this.initPosition.y,
            scale: 1,
            onComplete: () => {
                this.setInteractive({ useHandCursor: true })
            }
        })
    }
}